import React, { ReactElement } from 'react';
import { Container, withOverflowMenu } from "puzzle";
import { Component, PuzzleDropDownButton } from "puzzle"
import Menu from "@progress/kendo-react-layout/dist/npm/menu/components/Menu";
import MenuItem from "@progress/kendo-react-layout/dist/npm/menu/components/MenuItem";
import * as _ from 'lodash';

type task = {
  taskName: string,
  taskID: number
}

type extendedTask = {
  taskName: string,
  taskID: number,
  isDisabled: boolean
}

//TODO change ANY to appropriate type
type PROPS = {
  toolbar: any,
  onResize: any,
  decodedTasks: number[]
  innerRef: any
}

class ActionToolbarMenu extends Component<PROPS, {}> {

  /**
   * Creates menu with its items from elements marked as hidden in toolbar.
   */
  createMenuItems() {
    const { hiddenItems } = this.props.toolbar.getState();
    const collection = this.collectHiddenItemsData(hiddenItems);
    let actionsList = [];

    const collectionKeys = collection.keys();
    for (let actionKey of collectionKeys) {
      let menuItems = collection.get(actionKey).map(this.createChildItems);
      if (menuItems.length > 1) {
        actionsList.push((
          // @ts-ignore
          <Menu vertical={true}
                key={"menu" + actionKey}
                onSelect={this.onSelectHandler}
          >
            {/*
              // @ts-ignore*/}
            <MenuItem cssClass={'tp-list-item-lvl2'}
                      key={"menuGroup " + actionKey}
                      text={actionKey}>
              items = {menuItems}
            </MenuItem>
          </Menu>
        ));
      } else {
        // @ts-ignore
        actionsList.push((
          // @ts-ignore
          <Menu vertical={true}
                key={"menu" + actionKey}
                onSelect={this.onSelectHandler}>
            {/*
              // @ts-ignore*/}
            <MenuItem cssClass={'tp-list-item-lvl2'}
                      key={"menuGroup " + actionKey}
                      text={actionKey}>
            </MenuItem>
          </Menu>
        ));
      }

    }
    return actionsList;

  }

  createChildItems = (item: task) => {
    let disabled = item.taskID !== -1 && !_.isEmpty(this.props.decodedTasks) && !this.props.decodedTasks.includes(item.taskID);
    return (
      // @ts-ignore
      <MenuItem key={"menuItem" + item.taskName}
                disabled={disabled}
                text={item.taskName}/>
    )
  };

  getTaskNames(item: extendedTask) {
    return {
      taskName: item.taskName,
      taskID: item.taskID
    }
  }

  /**
   * Rips out data from dom elements that are marked as hidden and creates collection.
   * @param hiddenItems
   */
  collectHiddenItemsData(hiddenItems: ReactElement[]) {
    let collection = new Map();
    for (let hiddenItem in hiddenItems) {
      if (hiddenItems.hasOwnProperty(hiddenItem)) {
        const current = hiddenItems[hiddenItem].props;
        if (current.items) {
          const items = current.items.map(this.getTaskNames);
          collection.set(current.text, items);
        } else {
          let item = {
            taskName: current.value,
            taskID: -1,
            isDisabled: false
          };
          collection.set(current.value, [this.getTaskNames(item)]);
        }
      }
    }
    return collection;
  }

  /**
   * Handles menu item click
   * @param item
   */
  onSelectHandler = (item: any) => {
    if (!item.item.items) {
      //TODO logic for opening selected action Dialog
    }
  }

  /**
   * Creates array of elements marked as visible on toolbar recalculation
   */
  generateToolbarItems(items: React.ReactElement[]) {
    let array = items.map((item: ReactElement, index: number) => {
      let result = item;
      if (this.props.toolbar.getState().haveVisibleItems) {
        let toolbarChildrenCurrent = this.props.toolbar.context.childRef.current.element.children[index];
        if (toolbarChildrenCurrent.dataset.visibleComponent !== 'true') {
          //@ts-ignore
          result = null;
        }
      }
      return result;
    });
    return array
  }


  renderBody() {
    const { getItems, getState } = this.props.toolbar;
    const items = getItems();

    return (
      <Container
        ref={this.props.innerRef}
        className="tp-page-header-action-toolbar"
        gap={2}
        displayFlex
      >
        {this.generateToolbarItems(items)}
        {getState().haveHiddenItems ?
          <PuzzleDropDownButton
            themeColor={'primary'}
            buttonAriaLabel={this.translate('SRL-showMoreActions')}
            items={this.createMenuItems()}
            iconClass="tp-icon tp-more-vertical"
          />
          : null
        }
      </Container>
    );
  }
}

export default withOverflowMenu(ActionToolbarMenu);
